import { AddDoorComponentonWall, calculateLegsCount, updateBreezewayFrameAndStorages } from "../common/common.helper";
import { makeDimensionArray } from "../building/building_style/centreBuilding.helper";
import { makeComponentArray, handleDefaultDoorWindow } from "../building_component/doorWindows.helper";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
import * as utils from "../../redux/reducers/utils";
import { const_var, params } from "../../redux/reducers/reducer";
import { ManufacturesDefaultDetails } from "../../Constants/constant";
import { getGaugeRoofCost, setTrussType } from "./buildingPricing.helper";
import { getDrawingPrice } from "../extra_options_pricing/extra.pricing.helper";
import { removeAllCupolas } from "../building_component/buildingComponent.helper";
import { setHorizontalAndVerticalWalls } from "./wall_pricing/wallPricing.helper";
import { checkRoofPitch } from "../building/building_config/building.helper";

const setPricingData = async (state, response, flag, str, isEdit = false, reducerFns = {}) => {
	const { dynamicWallOptions, dynamicWallOptionsForLeanTo } = reducerFns;

	if (response.data?.roof_pitch?.length > 0 && const_var.crmSetting.is_Edit == true) {
		let roofPitchExits = response.data.roof_pitch.filter((style) => {
			if (style.roof_pitch?.split("/")?.[0] == params.p_r_p && (style.roof_ids.includes(params.p_r_s) || style.roof_ids.includes("0"))) {
				return style;
			}
		});
		if (roofPitchExits.length == 0) {
			let defaultRoof = response.data.roof_pitch.find((style) => style.is_default == "yes");
			if (defaultRoof != undefined) {
				params.p_r_p = defaultRoof.roof_pitch.split("/")[0];
				params.b_r_p = defaultRoof.roof_pitch.replace("/", "");
			}
		}
	}
	let responseStatus = flag == true && const_var.CallApionAction == false ? response.status : response.success;
	if (isEdit == true) {
		const_var.isDataWithlegCut = true;
	} else {
		const_var.isDataWithlegCut = false;
	}
	if (responseStatus == true) {
		let dataNew = flag == true && const_var.CallApionAction == false ? response.data.pricing_data : response.data;
		const_var.checkForCutPannel = dataNew.panel.length > 0 ? dataNew.panel[0].cut_panel_cost : 0;

		if (params.p_c_i == true && dataNew && dataNew.insulation && const_var.a_p_d_a && const_var.insulationPriceJson.insulation_wall && Object.keys(const_var.insulationPriceJson.insulation_wall).length > 0) {
			let isInsulationAdded = Object.keys(const_var.insulationPriceJson.insulation_wall).find((key) => const_var.insulationPriceJson.insulation_wall[key] == true);
			params.p_c_i = isInsulationAdded != undefined ? params.p_c_i : params.m_s_n == 153 && (params.add_left_lean || params.add_front_lean || params.add_back_lean || params.add_right_lean) ? params.p_c_i : false;
			params.p_f_i = false;
		}

		let singleSlopeHeight =
			const_var.c_m_a[params.p_b_t] != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined && const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
				? Math.floor(params.p_h - (params.p_w * params.p_r_p) / 12)
				: Math.round(params.p_h - (params.p_w * params.p_r_p) / 12);

		if (params.singleSlope == true && (params.p_c_i == true || params.p_r_o == true || params.p_f_i == true) && params.m_s_n == 153 && (params.p_r_s == 1 || params.p_r_s == 2) && singleSlopeHeight > 10) {
			params.p_c_i = false;
			params.p_r_o = false;
			params.p_f_i = false;
		}

		const_var.showGaugePriceVal = 0;
		state.const_var.b_n_B_d = dataNew.building_structure.length > 0 ? dataNew.building_structure[0].building_id : state.const_var.b_n_B_d;
		if (Object.keys(dataNew.anchors_cost).length > 0) {
			for (var i = 0; i <= dataNew.anchors_cost.length - 1; i++) {
				state.const_var.c_m_a_Anchors[dataNew.anchors_cost[i].name] = dataNew.anchors_cost[i];
			}
		}
		let countofLegs = const_var.count_numberofLegsBefore != undefined ? const_var.count_numberofLegsBefore : const_var.count_numberofLegs;
		if (dataNew.building_structure.length > 0) {
			if (Object.keys(dataNew.building_structure[0].conditions).length !== 0) {
			}
			let checkFourFeetOrNot = response.data?.extra_items?.[0]?.checkbox?.find((item) => item?.name == "fourth_center_cost");
			const_var.DistanceArr[params.p_b_t][params.p_r_s] =
				params.fourth_center_cost != true
					? checkFourFeetOrNot == undefined
						? const_var.DistanceArr[params.p_b_t][params.p_r_s]
						: dataNew.building_structure[0].distance_on_center
					: params.fourth_center_cost
						? 4
						: const_var.DistanceArr[params.p_b_t][params.p_r_s];
			if (const_var.DistanceArr[params.p_b_t][params.p_r_s] != dataNew.building_structure[0].distance_on_center) {
				const_var.DistanceArr[params.p_b_t][params.p_r_s] =
					params.fourth_center_cost != true ? (checkFourFeetOrNot == undefined ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : dataNew.building_structure[0].distance_on_center) : 4;
				cuBuilding.uUdDCB();
				cuBuilding.uUdD();

				if (params.isBreezeway && const_var.checkPickThisBuilding && const_var.isBreezewayPickThisBuilding && const_var.isPriceAPIcalled) {
					const_var.isBreezewayPickThisBuilding = false;
					params.p_u_t = const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 ? utils.findNearestMultipleOfFour(params.p_u_t) : utils.findNearestMultipleOfFive(params.p_u_t);
					params.cB_addStorage_front =
						const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4 ? utils.findNearestMultipleOfFour(params.cB_addStorage_front) : utils.findNearestMultipleOfFive(params.cB_addStorage_front);
					makeDimensionArray(state);
					updateBreezewayFrameAndStorages({ option: "pickThisBuilding" }, undefined, Number(params.p_h), Number(params.p_d));
				}
			}
			if (params.isBreezeway) makeDimensionArray(state);
			const_var.defaultDistanceOnCenter = dataNew.building_structure[0].distance_on_center;
		}
		if (dataNew?.side[0]?.lift_type != undefined && dataNew?.side[0]?.lift_type != "") {
			params.lift_type = params.lift_type == undefined ? false : true;
			params.lifttype_price = dataNew.side[0].lifttype_price;
			if (params.lift_type == true) {
				const_var.UpdatedPriceData.lifttype_price_changed = const_var.UpdatedPriceData.lifttype_price_changed == true ? undefined : const_var.UpdatedPriceData.lifttype_price_changed;
				if (const_var.UpdatedPriceData.lifttype_price_changed == false || const_var.UpdatedPriceData.lifttype_price_changed == undefined) {
					const_var.UpdatedPriceData.lifttype_price_changed = true;
				}
			}
		}
		if (dataNew.cupola != undefined && Object.keys(dataNew.cupola).length > 0) {
			if (Object.keys(dataNew.cupola).length === 1 && Object.keys(const_var.cupolasData).length > 0) {
				const isAddedCupolaAvilable = Object.keys(dataNew.cupola).filter((element) => Object.keys(const_var.cupolasData).includes(element));
				if (isAddedCupolaAvilable.length === 0) removeAllCupolas();
			}
			const_var.cupolaObj = dataNew.cupola;
			const_var.cupolasData = dataNew.cupola;
			const_var.cupolaType = Object.keys(const_var.cupolasData)[0];
		} else {
			const_var.cupolaObj = [];
			const_var.cupolasData = [];
			state.cupolaEditIconsPos = [];
			removeAllCupolas();
		}

		setHorizontalAndVerticalWalls(dataNew.side[0], dataNew.panel[0]);
		setTrussType({ dataNew, params, state, const_var });
		let gaugeCheck = params.gauge_val;
		params.gauge_val = dataNew.building_structure[0]?.default_gauge;
		const_var.g_v = dataNew.building_structure[0]?.default_gauge;
		if (dataNew.base.length == 2) {
			const_var.showGaugePrice = true;
		}

		if (dataNew?.base?.length > 0) {
			const Guagecost = getGaugeRoofCost(dataNew.base, params.p_r_s, params.gauge_val);
			const_var.showGaugePriceVal = Guagecost;
			const_var.showGaugePriceVal = utils.convertToTwoDecimalNumber(const_var.showGaugePriceVal);
			if (params.gauge_val != gaugeCheck) {
				const gaugeObj = dataNew.base.find((g) => Number(g.gauge) === Number(gaugeCheck));

				if (gaugeObj) {
					params.gauge_val = gaugeObj.gauge;
					const_var.g_v = params.gauge_val;
				}
			}
		}
		if (params.gauge_val == 12) {
			params.gauge_val_check = true;
		}
		state.const_var.a_p_d_a = dataNew;

		checkRoofPitch();

		if (const_var.a_p_d_a?.side_cross_bracing == undefined || const_var.a_p_d_a?.side_cross_bracing?.length == 0) {
			const_var.selected_scbracing = "";
			params.p_s_c_b = false;
		}
		if (const_var.a_p_d_a?.side_cross_bracing?.length == 1 && const_var.a_p_d_a?.side_cross_bracing[0].sheet_name == undefined) {
			const_var.a_p_d_a.side_cross_bracing[0]["sheet_name"] = "diagonal_braces";
			const_var.a_p_d_a.side_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
		}
		if (const_var.a_p_d_a?.side_cross_bracing?.length > 1) {
			let isNoneExsist = const_var.a_p_d_a.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
			if (isNoneExsist == undefined) {
				const_var.a_p_d_a.side_cross_bracing.push({
					map_id: 97,
					sheet_name: "none",
					sheet_label: "None",
					is_default: "yes",
					height: 6,
					length: 35,
					cost: 0
				});
			}
			if (const_var.crmSetting.is_Edit != true) {
				let defaultSelected = const_var.a_p_d_a.side_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
				let isBracingExist = const_var.a_p_d_a.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selected_scbracing);
				if (defaultSelected != undefined || isBracingExist) {
					const_var.selected_scbracing = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
					params.p_s_c_b = const_var.selected_scbracing != "none" ? true : false;
				} else {
					params.p_s_c_b = false;
					const_var.selected_scbracing = "none";
				}
			} else {
				if (const_var.selected_scbracing == "") {
					params.p_s_c_b = false;
					const_var.selected_scbracing = "none";
				}
			}
		}
		if (const_var.a_p_d_a?.side_cross_bracing?.length == 1) {
			if (const_var.a_p_d_a?.side_cross_bracing[0].is_default != "included") {
				let isNoneExsist = const_var.a_p_d_a?.side_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.a_p_d_a.side_cross_bracing.push({
						map_id: 97,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: 6,
						length: 35,
						cost: 0
					});
				}
			}

			let isBracingExsist =
				const_var.selected_scbracing != "" && const_var.selected_scbracing != "none" ? const_var.a_p_d_a.side_cross_bracing.find((obj) => obj.sheet_name == const_var.selected_scbracing) : undefined;
			if (isBracingExsist == undefined) {
				if (const_var.a_p_d_a?.side_cross_bracing[0].is_default == "included") {
					const_var.selected_scbracing = const_var.a_p_d_a?.side_cross_bracing[0].sheet_name;
					params.p_s_c_b = true;
				} else {
					params.p_s_c_b = false;
					const_var.selected_scbracing = "none";
				}
			}
		}

		if (const_var.a_p_d_a?.end_cross_bracing == undefined || const_var.a_p_d_a?.end_cross_bracing?.length == 0) {
			const_var.selected_ecbracing = "";
			params.p_e_c_b = false;
		}
		if (const_var.a_p_d_a?.end_cross_bracing?.length == 1 && const_var.a_p_d_a?.end_cross_bracing[0].sheet_name == undefined) {
			const_var.a_p_d_a.end_cross_bracing[0]["sheet_name"] = "diagonal_braces";
			const_var.a_p_d_a.end_cross_bracing[0]["sheet_label"] = "Diagonal Braces";
		}
		if (const_var.a_p_d_a?.end_cross_bracing?.length > 1) {
			let isNoneExsist = const_var.a_p_d_a.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
			if (isNoneExsist == undefined) {
				const_var.a_p_d_a.end_cross_bracing.push({
					map_id: 97,
					sheet_name: "none",
					sheet_label: "None",
					is_default: "yes",
					height: 6,
					length: 35,
					cost: 0
				});
			}
			if (const_var.crmSetting.is_Edit != true) {
				let defaultSelected = const_var.a_p_d_a.end_cross_bracing.find((obj) => obj.is_default == "included" /* 'yes' */);
				let isBracingExist = const_var.a_p_d_a.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selected_ecbracing);
				if (defaultSelected != undefined || isBracingExist) {
					const_var.selected_ecbracing = isBracingExist ? isBracingExist.sheet_name : defaultSelected.sheet_name;
					params.p_e_c_b = const_var.selected_ecbracing != "none" ? true : false;
				} else {
					params.p_e_c_b = false;
					const_var.selected_ecbracing = "none";
				}
			} else {
				if (const_var.selected_ecbracing == "") {
					params.p_e_c_b = false;
					const_var.selected_ecbracing = "none";
				}
			}
		}
		if (const_var.a_p_d_a?.end_cross_bracing?.length == 1) {
			if (const_var.a_p_d_a?.end_cross_bracing[0].is_default != "included") {
				let isNoneExsist = const_var.a_p_d_a.end_cross_bracing.find((obj) => obj && obj.sheet_name == "none");
				if (isNoneExsist == undefined) {
					const_var.a_p_d_a.end_cross_bracing.push({
						map_id: 97,
						sheet_name: "none",
						sheet_label: "None",
						is_default: "yes",
						height: 6,
						length: 35,
						cost: 0
					});
				}
			}

			let isBracingExsist =
				const_var.selected_ecbracing != "" && const_var.selected_ecbracing != "none" ? const_var.a_p_d_a.end_cross_bracing.find((obj) => obj.sheet_name == const_var.selected_ecbracing) : undefined;
			if (isBracingExsist == undefined) {
				if (const_var.a_p_d_a?.end_cross_bracing[0].is_default == "included") {
					const_var.selected_ecbracing = const_var.a_p_d_a?.end_cross_bracing[0].sheet_name;
					params.p_e_c_b = true;
				} else {
					params.p_e_c_b = false;
					const_var.selected_ecbracing = "none";
				}
			}
		}

		state.const_var.cbInsulation = dataNew.insulation;

		if (
			(params.add_front_lean == true || params.add_left_lean == true || params.add_right_lean == true || params.add_back_lean == true) &&
			(const_var.a_p_d_a.connection_fees == undefined || const_var.a_p_d_a.connection_fees.length == 0)
		) {
			if (params.add_left_lean == true && const_var.leanGetDataLeft != undefined && const_var.leanGetDataLeft.connection_fees != undefined) {
				const_var.a_p_d_a.connection_fees = const_var.leanGetDataLeft.connection_fees;
			}
			if (params.add_front_lean == true && const_var.leanGetDataFront != undefined && const_var.leanGetDataFront.connection_fees != undefined) {
				const_var.a_p_d_a.connection_fees = const_var.leanGetDataFront.connection_fees;
			}
			if (params.add_back_lean == true && const_var.leanGetDataBack != undefined && const_var.leanGetDataBack.connection_fees != undefined) {
				const_var.a_p_d_a.connection_fees = const_var.leanGetDataBack.connection_fees;
			}
			if (params.add_right_lean == true && const_var.leanGetDataRight != undefined && const_var.leanGetDataRight.connection_fees != undefined) {
				const_var.a_p_d_a.connection_fees = const_var.leanGetDataRight.connection_fees;
			}
		}

		let filterRoofPitchData = "";
		if (params.p_r_s == 1 && params.m_s_n == 13) {
			state.const_var.BuildingRoofPitch = [];

			filterRoofPitchData = state.const_var.a_p_d_a.roof_pitch != undefined ? state.const_var.a_p_d_a.roof_pitch.filter((data) => params.m_s_n == 13 && params.p_r_s == 1 && data.roof_pitch.split("/")[0] <= 3) : "";
			if (filterRoofPitchData != "" && filterRoofPitchData.length > 0) {
				dataNew.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
				state.const_var.a_p_d_a.roof_pitch = JSON.parse(JSON.stringify(filterRoofPitchData));
				if (filterRoofPitchData.filter((data) => data.roof_pitch?.replace("/", "") == params.b_r_p).length == 0) {
					let chkData = filterRoofPitchData.filter((data) => data.is_default == "yes");
					if (chkData.length > 0) {
						state.params.b_r_p = chkData[0].roof_pitch.replace("/", "");
						if (
							params.singleSlope == true &&
							const_var.c_m_a[params.p_b_t] != undefined &&
							const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
							const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						) {
							let newRoofPitch = Number(chkData[0].roof_pitch.split("/")[0]) - 1;
							state.params.p_r_p = newRoofPitch;
						} else {
							state.params.p_r_p = chkData[0].roof_pitch.split("/")[0];
						}
					} else {
						state.params.b_r_p = filterRoofPitchData[0].roof_pitch.replace("/", "");
						if (
							params.singleSlope == true &&
							const_var.c_m_a[params.p_b_t] != undefined &&
							const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
							const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
						) {
							let newRoofPitch = Number(filterRoofPitchData[0].roof_pitch.split("/")[0]) - 1;
							state.params.p_r_p = newRoofPitch;
						} else {
							state.params.p_r_p = filterRoofPitchData[0].roof_pitch.split("/")[0];
						}
					}
					cuBuilding.BuildingUpdate(true, "");
				}
			}
		}

		let DataNewDrawing = const_var.c_m_a?.[params.p_b_t]?.drawings ?? [];

		if (const_var.crmSetting.is_Edit !== true && DataNewDrawing.length > 0 && const_var.order_extra_items["engineer_drawings_name"] != "None") {
			let drawingCost = DataNewDrawing.find((obj) => obj.name == const_var.order_extra_items["engineer_drawings_name"]);
			if (drawingCost != undefined) {
				const_var.order_extra_items["engineer_drawings"] = getDrawingPrice(drawingCost, const_var.post_data);
			}
		}
		if ((const_var?.editAPIDataByResponse?.data?.main_created_at > "2024-03-06" && const_var.crmSetting.duplicate_module != "" && !DataNewDrawing?.length) || DataNewDrawing.length == 0) {
			const_var.isMultiSelectDrawingOpt = false;
			const_var.order_extra_items["engineer_drawings_name"] = "";
		}

		let updateEDCost = const_var?.editAPIDataByResponse?.data?.main_created_at <= "2024-03-06" ? false : true;

		if (DataNewDrawing?.length > 0 && updateEDCost == true) {
			if (const_var?.editAPIDataByResponse?.data?.main_created_at > "2024-03-06") {
				let editSelOpt = const_var.editAPIDataByResponse?.data?.request_data?.building?.order_extra_items?.engineer_drawings_name ?? "";
				let isSelOptExsist = editSelOpt != "" ? DataNewDrawing.filter((obj) => obj.name.toLowerCase() == editSelOpt.toLowerCase()) : [];
				if (isSelOptExsist.length > 0 && const_var.isFromStateChange == false && (params.m_s_n != 3 || (params.m_s_n == 3 && const_var.crmSetting.is_Edit))) {
					const_var.order_extra_items["engineer_drawings_name"] = editSelOpt;
					const_var.order_extra_items["engineer_drawings"] = const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings;
				} else {
					let risk1Cost = DataNewDrawing.filter((obj) => obj.is_default == "yes");
					const_var.order_extra_items["engineer_drawings_name"] = risk1Cost.length > 0 ? risk1Cost[0].name : "";
					const_var.order_extra_items["engineer_drawings"] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0;
				}
			} else {
				if (
					const_var.isKLinkEnable != true &&
					const_var.editAPIDataByResponse &&
					const_var.editAPIDataByResponse.data &&
					const_var.editAPIDataByResponse.data.main_created_at != undefined &&
					const_var.editAPIDataByResponse.data.main_created_at <= "2024-03-06"
				) {
					let editSelOpt =
						(const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings_name == undefined ||
							const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings_name == "") &&
						const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings != undefined &&
						const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings != ""
							? "Engineered Drawing"
							: "";

					let isSelOptExsist = editSelOpt != "" ? DataNewDrawing.filter((obj) => obj.name.toLowerCase() == editSelOpt.toLowerCase()) : [];

					if (isSelOptExsist.length > 0 && const_var.isFromStateChange == false) {
						const_var.order_extra_items["engineer_drawings_name"] = editSelOpt;
						const_var.order_extra_items["engineer_drawings"] = const_var.editAPIDataByResponse.data.request_data.building.order_extra_items.engineer_drawings;
					} else {
						let risk1Cost = DataNewDrawing.filter((obj) => obj.is_default == "yes");
						const_var.order_extra_items["engineer_drawings_name"] = risk1Cost.length > 0 ? risk1Cost[0].name : "";
						const_var.order_extra_items["engineer_drawings"] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0;
					}
				} else {
					if (const_var.isKLinkEnable != true) {
						const name = const_var.order_extra_items?.engineer_drawings_name;
						let TempObj = name ? DataNewDrawing.filter((obj) => obj.name.toLowerCase() == name.toLowerCase()) : [];
						let isExsist = TempObj.length > 0 ? true : false;
						if (const_var.order_extra_items?.engineer_drawings_name && isExsist == true && const_var.isFromStateChange == false) {
							const_var.order_extra_items["engineer_drawings_name"] = const_var.order_extra_items["engineer_drawings_name"];

							const_var.order_extra_items["engineer_drawings"] = const_var.order_extra_items["engineer_drawings"];
						} else {
							let risk1Cost = DataNewDrawing.find((obj) => obj.is_default == "yes");
							const_var.order_extra_items["engineer_drawings_name"] = risk1Cost.length > 0 ? risk1Cost.name : "";
							const_var.order_extra_items["engineer_drawings"] = getDrawingPrice(risk1Cost, const_var.post_data);
						}
					}
					if (
						const_var.isKLinkEnable == true &&
						const_var.order_extra_items?.engineer_drawings_name != "" &&
						const_var.editAPIDataByResponse &&
						const_var?.editAPIDataByResponse?.data.main_created_at > "2024-03-06"
					) {
						let isvalueExsist = DataNewDrawing.filter((obj) => obj.name == const_var.order_extra_items.engineer_drawings_name);
						if (isvalueExsist.length == 0) {
							let risk1Cost = DataNewDrawing.filter((obj) => obj.is_default == "yes");
							const_var.order_extra_items["engineer_drawings_name"] = risk1Cost.length > 0 ? risk1Cost[0].name : "";
							const_var.order_extra_items["engineer_drawings"] = risk1Cost.length > 0 ? risk1Cost[0].cost : 0;
						}
					}
				}
			}
		}
		cuBuilding.makeCertificateArray();
		dynamicWallOptions(state);
		dynamicWallOptionsForLeanTo(state);

		if (str == "h" || str == "roofstyle") {
			cuBuilding.CheckLegsByResponse(state);
		} else {
			if (str == "w" || str == "l") {
				cuBuilding.CheckLegsByResponse(state);
			}
			cuBuilding.BuildingUpdate(true, "");
		}
		if (const_var.isCheckGroundCertificate == true && const_var.UpdatedPriceData["elements"] != undefined && const_var.UpdatedPriceData["elements"]["Ground Certification"] != undefined) {
			const_var.UpdatedPriceData["elements"]["Ground Certification"].is_edit = false;
		}

		if (
			const_var.crmSetting.is_Edit == true &&
			const_var.isCheckGroundCertificate != undefined &&
			const_var.isCheckGroundCertificate == true &&
			(params.m_s_n == 11 || params.m_s_n == 54 || params.m_s_n == 147 || params.m_s_n == 160)
		) {
			utils.surfaceCertificateApplied(state);
		}

		if (dataNew.roof_pitch != undefined && dataNew.roof_pitch.length > 0) {
			state.const_var.b_r_p_a = [];

			var data = state.const_var.a_p_d_a;
			var chkPitchDataforRoof = false;
			if (data.roof_pitch.length > 0) {
				let chkPitchData = data.roof_pitch.filter((data) => data.roof_pitch?.replace("/", "") == params.b_r_p);
				if (chkPitchData != undefined && chkPitchData.length == 0) {
					state.const_var.BuildingRoofPitch = [];
					chkPitchDataforRoof = true;
				}
			}
			if (const_var.crmSetting.is_Edit && response.data.fixed_new_leg_width != undefined && response.data.fixed_new_leg_width.length > 0) {
				state.const_var.BuildingRoofPitch = [];
				chkPitchDataforRoof = true;
				state.c_m_a[state.params.p_b_t].fixed_new_leg_width = response.data.fixed_new_leg_width;
				makeDimensionArray(state);
			}
			state.const_var.BuildingRoofPitchObj = {};
			for (var i = 0; i <= data.roof_pitch.length - 1; i++) {
				let repl = data.roof_pitch[i].roof_pitch.split("/");

				if (data.roof_pitch[i].roof_ids != undefined) {
					if (data.roof_pitch[i].roof_ids.includes(params.p_r_s) || data.roof_pitch[i].roof_ids.includes("0")) {
						state.const_var.b_r_p_a[data.roof_pitch[i].roof_pitch.replace("/", "")] = data.roof_pitch[i];
						state.const_var.BuildingRoofPitch[data.roof_pitch[i].roof_pitch] = data.roof_pitch[i].roof_pitch.replace("/", "");
						state.const_var.BuildingRoofPitchObj[data.roof_pitch[i].roof_pitch] = data.roof_pitch[i];
						state.const_var.BuildingRoofPitchObj[data.roof_pitch[i].roof_pitch].is_default = data.roof_pitch[i].is_default;
					}
				} else {
					state.const_var.b_r_p_a[data.roof_pitch[i].roof_pitch.replace("/", "")] = data.roof_pitch[i];
					state.const_var.BuildingRoofPitch[data.roof_pitch[i].roof_pitch] = data.roof_pitch[i].roof_pitch.replace("/", "");
					state.const_var.BuildingRoofPitchObj[data.roof_pitch[i].roof_pitch] = data.roof_pitch[i];
				}
				if (data.roof_pitch[i].is_default == "yes" && (data.roof_pitch[i].roof_ids.includes(params.p_r_s) || data.roof_pitch[i].roof_ids.includes("0"))) {
					state.const_var.checkRoofDefault = data.roof_pitch[i].roof_pitch.replace("/", "");
					if (state.params.b_r_p !== state.const_var.checkRoofDefault && const_var.crmSetting.is_Edit !== true) {
						let otherBuildingExist =
							state.const_var.defaultBuildingJson.id !== undefined && state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id] !== undefined
								? state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id].other_building_id.split(",")
								: [];
						if (
							const_var.c_m_a[params.p_b_t] != undefined &&
							const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
							const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0 &&
							otherBuildingExist.length > 0 &&
							state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id].central_roof_pitch !== undefined
						) {
							state.params.b_r_p = state.const_var.checkRoofDefault;
							state.params.p_r_p = Number(data.roof_pitch[i].roof_pitch.split("/")[0]);
							const_var.UpdatedPriceData.roof_pitch_price_changed = true;
							state.const_var.defaultBuildingArr[state.const_var.defaultBuildingJson.id].central_roof_pitch = data.roof_pitch[i].roof_pitch;
							cuBuilding.BuildingUpdate(true, "");
						}
					}
				}
				if (data.roof_pitch[i].is_default == "yes" && const_var.CallApionAction == false && (data.roof_pitch[i].roof_ids.includes(params.p_r_s) || data.roof_pitch[i].roof_ids.includes("0"))) {
					state.params.b_r_p = data.roof_pitch[i].roof_pitch.replace("/", "");
					if (
						params.singleSlope == true &&
						const_var.c_m_a[params.p_b_t] != undefined &&
						const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
						const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
					) {
						let newRoofPitch = Number(data.roof_pitch[i].roof_pitch.split("/")[0]) - 1;
						state.params.p_r_p = newRoofPitch;
					} else {
						state.params.p_r_p = data.roof_pitch[i].roof_pitch.split("/")[0];
					}
				}
				if (data.roof_pitch[i].is_default == "yes" && chkPitchDataforRoof == true && (data.roof_pitch[i].roof_ids.includes(params.p_r_s) || data.roof_pitch[i].roof_ids.includes("0"))) {
					state.params.b_r_p = data.roof_pitch[i].roof_pitch.replace("/", "");
					if (
						params.singleSlope == true &&
						const_var.c_m_a[params.p_b_t] != undefined &&
						const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
						const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
					) {
						let newRoofPitch = Number(data.roof_pitch[i].roof_pitch.split("/")[0]) - 1;
						state.params.p_r_p = newRoofPitch;
					} else {
						state.params.p_r_p = data.roof_pitch[i].roof_pitch.split("/")[0];
					}
				}
			}
			if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
				makeDimensionArray(state);
			}
			if (const_var.b_o_J_1[params.p_b_t].includes("Free Standing Lean-to")) {
				cuBuilding.BuildingUpdate(true, "");
			}
			const { m_s_n, p_r_s } = { ...state.params };
			const isRegularRoofStyle = p_r_s == ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.roofStyle;

			const isJVMetalsMfgWithDefaultRoofStyle =
				ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.id == m_s_n &&
				Object.values(const_var.BuildingRoofPitch).includes(ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.defaultRoofPitch) &&
				isRegularRoofStyle;

			const selectedRoof = Object.values(const_var.BuildingRoofPitch).find((item) => item == ManufacturesDefaultDetails.JV_METALS_BUILDING_LLC.defaultRoofPitch);
			if (isJVMetalsMfgWithDefaultRoofStyle && selectedRoof && const_var.crmSetting.is_Edit == false && const_var.isRoofPitchChangedManually) {
				state.params.b_r_p = selectedRoof;
				state.const_var.checkRoofDefault = selectedRoof;
				const_var.isRoofPitchChangedManually = false;
			} else {
				state.params.b_r_p = state.params.b_r_p != "" ? state.params.b_r_p : "Select";
			}
		}
		if (params.add_left_lean == true && const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
			const_var.leanGetDataLeft.central_side = undefined;
		}
		if (params.add_left_lean == true && const_var.leanGetDataLeft.central_end != undefined && const_var.leanGetDataLeft.central_end.length > 0) {
			const_var.leanGetDataLeft.central_end = undefined;
		}
		if (params.add_right_lean == true && const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
			const_var.leanGetDataRight.central_side = undefined;
		}
		if (params.add_right_lean == true && const_var.leanGetDataRight.central_end != undefined && const_var.leanGetDataRight.central_end.length > 0) {
			const_var.leanGetDataRight.central_end = undefined;
		}

		const componentData = const_var.crmSetting.is_Edit ? const_var.editAPIDataByResponse?.data.building_data.component_data : const_var.componentData;
		state.c_m_a[state.params.p_b_t].garage_door = componentData.garage_doors;
		state.c_m_a[state.params.p_b_t].walkings = componentData.walk_in_doors;
		state.c_m_a[state.params.p_b_t].windows = componentData.windows;
		state.c_m_a[state.params.p_b_t].garage_door_frameout = [];
		state.c_m_a[state.params.p_b_t].walkin_door_frameout = [];
		state.c_m_a[state.params.p_b_t].window_frameout = [];

		state.c_m_a[state.params.p_b_t].garage_door_v3 = componentData.garage_doors;
		state.c_m_a[state.params.p_b_t].garage_door_frameout_v3 = [];
		state.c_m_a[state.params.p_b_t].walkin_door_frameout_v3 = [];
		state.c_m_a[state.params.p_b_t].window_frameout_v3 = [];
		if (componentData.walk_in_doors) {
			state.c_m_a[state.params.p_b_t].walkin_door_v3 = componentData.walk_in_doors;
			state.c_m_a[state.params.p_b_t].window_v3 = componentData.windows;
		}

		if (const_var.selectedLeanType === "") {
			const_var.CustomDoorArr = {
				Garage: {
					Size: {},
					Object: {},
					SidePrice: {},
					EndPrice: {},
					TrimKit: {},
					Chain_Hoist: {},
					Header_Seal: {},
					Is_Chain_Hoist: {},
					Is_Header_Seal: {},
					Is_Certified: {},
					Certified_Cost: {},
					Is_Automatic_Openers: {},
					Automatic_Openers_Cost: {},
					garageDoorColor: {}
				},
				sectionalGarage: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {}, TrimKit: {}, Chain_Hoist: {}, Header_Seal: {} },
				Walk: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
				WalkFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
				Windows: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
				WindowsFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {} },
				GarageFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {}, TrimKit: {} },
				CustomFrameout: { Size: {}, Object: {}, SidePrice: {}, EndPrice: {}, TrimKit: {}, Width: {}, Height: {} }
			};
			const_var.customFrameoutInitialSize = "";
			if (const_var.crmSetting.is_Edit) {
				makeComponentArray(state, {
					type: "makeComponentAction",
					value: {
						garage_doors: componentData.garage_doors,
						walk_in_doors: componentData.walk_in_doors,
						windows: componentData.windows
					}
				});
			}
		}
		if (state.const_var.defaultProData.roof_pitch != undefined && state.const_var.defaultProData.roof_pitch != params.b_r_p && const_var.CallApionAction == false) {
			state.params.b_r_p = state.const_var.defaultProData.roof_pitch?.replace("/", "");
		}

		cuBuilding.makeExtraElements();
		if (const_var.crmSetting.is_Edit == true) {
			// if (const_var.c_f_aCer[params.p_e_i] != undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center != undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center != 5) {
			// 	utils.calculateFourthCenterCostwithExtraBows();
			// }

			if (
				const_var.editAPIDataByResponse != undefined &&
				const_var.editAPIDataByResponse.data != undefined &&
				const_var.editAPIDataByResponse.data.request_data != undefined &&
				const_var.editAPIDataByResponse.data.request_data.building != undefined &&
				(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97)
			) {
				if (params.p_l_w.toLowerCase() != const_var.editAPIDataByResponse.data.request_data.building.left_wall.toLowerCase()) {
					const_var.UpdatedPriceData.left_wall_price_changed = true;
				}
				if (params.p_r_w.toLowerCase() != const_var.editAPIDataByResponse.data.request_data.building.right_wall.toLowerCase()) {
					const_var.UpdatedPriceData.right_wall_price_changed = true;
				}
				let editedFrontWall =
					const_var.editAPIDataByResponse.data.request_data.building.front_wall.toLowerCase() == "extended_gable"
						? const_var.editAPIDataByResponse.data.request_data.building.front_wall.replace("_", " ")
						: const_var.editAPIDataByResponse.data.request_data.building.front_wall;
				let editedBackall =
					const_var.editAPIDataByResponse.data.request_data.building.back_wall.toLowerCase() == "extended_gable"
						? const_var.editAPIDataByResponse.data.request_data.building.back_wall.replace("_", " ")
						: const_var.editAPIDataByResponse.data.request_data.building.back_wall;
				if (params.p_f_w.toLowerCase() != editedFrontWall.toLowerCase()) {
					const_var.UpdatedPriceData.front_wall_price_changed = true;
				}
				if (params.p_b_w.toLowerCase() != editedBackall.toLowerCase()) {
					const_var.UpdatedPriceData.back_wall_price_changed = true;
				}
			}
		}

		cuBuilding.cP();
		if (params.p_b_w == "Close" && params.p_l_w == "Close" && params.p_r_w == "Close" && params.p_f_w == "Close") {
			state.isFullyEnclosedChecked = true;
		}
		if (state.params.p_b_c_b_l_f == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l == "Close") {
			state.isFullyEnclosedCheckedForLeftLeanTo = true;
		}
		if (state.params.p_b_c_b_r_f == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r == "Close") {
			state.isFullyEnclosedCheckedForRightLeanTo = true;
		}
		if (state.params.p_b_c_b_l_f == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l == "Open") {
			state.isFullyOpenedCheckedForLeftLeanTo = true;
		}
		if (state.params.p_b_c_b_r_f == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r == "Open") {
			state.isFullyOpenedCheckedForRightLeanTo = true;
		}
		let checkWallVal = false;
		if (
			const_var.crmSetting.is_Edit == false &&
			(params.p_f_w == "Close" ||
				params.p_b_w == "Close" ||
				params.p_l_w == "Close" ||
				params.p_r_w == "Close" ||
				state.const_var?.defaultBuildingImgName == "Utility_Buildings" ||
				state.const_var?.defaultBuildingImgName?.includes("Breezeway_Building"))
		) {
			checkWallVal = true;
		}

		if (
			const_var.CallApionAction == false &&
			const_var.crmSetting.is_Edit == false &&
			const_var.defaultBuildingArr[const_var.selectedDefaultIndex] != undefined &&
			const_var.defaultBuildingArr[const_var.selectedDefaultIndex].central_roof_pitch != undefined &&
			const_var.defaultBuildingArr[const_var.selectedDefaultIndex].central_roof_pitch != null
		) {
			state.params.b_r_p =
				const_var.otherBuildingRoofPitch && const_var.otherBuildingRoofPitch != ""
					? const_var.otherBuildingRoofPitch + "12"
					: const_var.defaultBuildingArr[const_var.selectedDefaultIndex].central_roof_pitch?.replace("/", "");
			if (
				params.singleSlope == true &&
				const_var.c_m_a[params.p_b_t] != undefined &&
				const_var.c_m_a[params.p_b_t].fixed_new_leg_width != undefined &&
				const_var.c_m_a[params.p_b_t].fixed_new_leg_width.length > 0
			) {
				let newRoofPitch = Number(const_var.defaultBuildingArr[const_var.selectedDefaultIndex].central_roof_pitch.split("/")[0]) - 1;
				state.params.p_r_p = newRoofPitch;
			} else {
				state.params.p_r_p =
					const_var.otherBuildingRoofPitch && const_var.otherBuildingRoofPitch != ""
						? const_var.otherBuildingRoofPitch
						: const_var.defaultBuildingArr[const_var.selectedDefaultIndex].central_roof_pitch.split("/")[0];
			}
		}
		if (const_var.crmSetting.is_Edit == false && const_var.defaultBuildingArr[state.defaultBuilding] != undefined) {
			var chkEndJtrim = false;
			var chkSideJtrim = false;
			if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
				chkEndJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
				chkSideJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
				if (params.p_f_w != "Open" && params.p_f_w != "Close" && params.p_f_w != "Half Dutch End" && params.p_f_w != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_w != "Open" && params.p_b_w != "Close" && params.p_b_w != "Half Dutch End" && params.p_b_w != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_l_w != "Open" && params.p_l_w != "Close" && chkSideJtrim == true) {
					params.p_j_t = true;
				}
				if (params.p_r_w != "Open" && params.p_r_w != "Close" && chkSideJtrim == true) {
					params.p_j_t = true;
				}
				if (params.p_b_c_b_f_f != "Open" && params.p_b_c_b_f_f != "Close" && params.p_b_c_b_f_f != "Half Dutch End" && params.p_b_c_b_f_f != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_f_b != "Open" && params.p_b_c_b_f_b != "Close" && params.p_b_c_b_f_b != "Half Dutch End" && params.p_b_c_b_f_b != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_f_l != "Open" && params.p_b_c_b_f_l != "Close" && chkSideJtrim == true) {
					params.p_j_t = true;
				}
				if (params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close" && params.p_b_c_b_b_b != "Half Dutch End" && params.p_b_c_b_b_b != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_b_l != "Open" && params.p_b_c_b_b_l != "Close" && chkSideJtrim == true) {
					params.p_j_t = true;
				}
				if (params.p_b_c_b_b_f != "Open" && params.p_b_c_b_b_f != "Close" && params.p_b_c_b_b_f != "Half Dutch End" && params.p_b_c_b_b_f != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_l_f != "Open" && params.p_b_c_b_l_f != "Close" && params.p_b_c_b_l_f != "Half Dutch End" && params.p_b_c_b_l_f != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close" && params.p_b_c_b_l_b != "Half Dutch End" && params.p_b_c_b_l_b != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_l != "Open" && params.p_b_c_b_l != "Close" && chkSideJtrim == true) {
					params.p_j_t = true;
				}
				if (params.p_b_c_b_r_f != "Open" && params.p_b_c_b_r_f != "Close" && params.p_b_c_b_r_f != "Half Dutch End" && params.p_b_c_b_r_f != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close" && params.p_b_c_b_r_b != "Half Dutch End" && params.p_b_c_b_r_b != "Half End" && chkEndJtrim == true) {
					params.p_j_t_end = true;
				}
				if (params.p_b_c_b_r != "Open" && params.p_b_c_b_r != "Close" && chkSideJtrim == true) {
					params.p_j_t = true;
				}
			}
		}

		if (
			const_var.crmSetting.is_Edit == false &&
			checkWallVal == true &&
			state.const_var.defalutProductLoad == true &&
			const_var.defaultBuildingArr[state.defaultBuilding].default_doors != undefined &&
			const_var.defaultBuildingArr[state.defaultBuilding].default_doors != null &&
			const_var.defaultBuildingArr[state.defaultBuilding].default_doors.length > 0
		) {
			const_var.CheckDoorForEdit = true;
			cuComponent.removeAlltheComponent();

			const doors = handleDefaultDoorWindow({
				const_var,
				state,
				params,
				isEdit,
				AddDoorComponentonWall
			});
			if (state.params.p_f_w === "Close" && state.params.p_r_w === "Close" && state.params.p_l_w === "Close" && state.params.p_b_w === "Close") {
				const_var.setSidesEndsWallOption = "close";
			} else if (state.params.p_f_w === "Open" && state.params.p_r_w === "Open" && state.params.p_l_w === "Open" && state.params.p_b_w === "Open" && state.params.p_c_p_l == false && state.params.p_c_p_r == false) {
				const_var.setSidesEndsWallOption = "open";
			} else {
				const_var.setSidesEndsWallOption = "partial";
			}

			cuBuilding.cP();
		} else {
			if ((const_var.entry_points == undefined || const_var.entry_points.length == 0) && document.querySelector("body").classList.contains("active-modal-loader")) {
				document.querySelector("body").classList.remove("active-modal-loader");
			}
			const_var.isCheckDisabled = false;
		}

		const_var.defalutProductLoad = false;

		const_var.is_loader = false;

		if (params.building_type_name != "" && params.building_type_name === "Custom Buildings") {
			const_var.checkmoreCustomizeFlag = true;
		} else {
			const_var.checkmoreCustomizeFlag = false;
		}

		if (const_var?.defaultBuildingArr[state.defaultBuilding]?.default_doors?.length == 0 || const_var?.defaultBuildingArr[state.defaultBuilding]?.default_doors?.length == undefined) {
			document.querySelector("body").classList.remove("active-modal-loader");
		}
	}

	if (const_var.crmSetting.is_Edit != true) {
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.frontLean_truss_price_changed = true;
		const_var.UpdatedPriceData.backLean_truss_price_changed = true;
		const_var.UpdatedPriceData.leftLean_truss_price_changed = true;
		const_var.UpdatedPriceData.rightLean_truss_price_changed = true;
	}
};

export default setPricingData;
